<mat-toolbar class="custom-navbar">
  <div class="container">
    <button mat-icon-button class="humburger" *ngIf="isLoggedIn" (click)="toggle()">
      <img *ngIf="!isCollapsed" src="/assets/icons/left Arrow.svg" alt="left-arrow icon" />
      <img *ngIf="isCollapsed" src="/assets/icons/Right Arrow.svg" alt="right-arrow icon" />
    </button>

    <div class="wrapper-header">
      <a routerLink="/" class="navbar-brand">
        <img src="/assets/icons/logo.svg" class="logo" alt="netsynico logo" />
      </a>

      <div class="username-wrapper" *ngIf="!isLoggedIn">
        <button mat-icon-button disableRipple="true" [matMenuTriggerFor]="signin_menu">
          <span class="link">Sign in<mat-icon class="link" style="margin-left: 0.2rem">login</mat-icon></span>
        </button>
        <mat-menu #signin_menu="matMenu">
          <div>
            <a class="link" (click)="onLogin('auth0')" routerLink="">Customer</a>
          </div>
          <div>
            <a class="link" (click)="onLogin('azure')" routerLink="">Employee</a>
          </div>
        </mat-menu>
      </div>
      <div class="username-wrapper" *ngIf="isLoggedIn">
        <button class="username" mat-icon-button disableRipple [matMenuTriggerFor]="menu">
          <img src="/assets/icons/profile-icon.svg" alt="profile-icon" />
          <span class="given-name">{{ getClaims()?.given_name }}</span>
          <i class="material-icons"> expand_more </i>
        </button>
        <mat-menu #menu="matMenu" panelClass="user-profile-menu" xPosition="after">
          <div class="menu-header">
            <div class="menu-avatar">{{ (getClaims()?.given_name || getClaims()?.name || '?').charAt(0).toUpperCase() }}</div>
            <div class="menu-user-details">
              <ng-container *ngIf="getClaims()?.name || isLoading">
                <span class="menu-username" [class.blur-text]="blurHelper.enableBlur">
                  {{ getClaims()?.name | titlecase }}
                  <img id="auth0-azure-logo" [src]="getImage()" alt="logo" />
                </span>
              </ng-container>
              <ng-container *ngIf="getRoles() || isLoading">
                <div class="menu-meta">
                  <span class="menu-role" [class.blur-text]="blurHelper.enableBlur">{{ getRoles() }}</span>
                  <span class="menu-cid" [class.blur-text]="blurHelper.enableBlur">{{ customerId }}</span>
                </div>
              </ng-container>
            </div>

          </div>
          
          @if ((isAdmin || isPresalesEngineer) && !isCustomerAdmin) {
            <div class="assume-block" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <div class="assume-header">
                <mat-icon class="assume-header__icon">manage_accounts</mat-icon>
                <span class="assume-header__label">Assume a Customer</span>
              </div>

              @if (imp.isImpersonating) {
                <div class="assume-active-card">
                  <div class="assume-active-card__info">
                    <span class="assume-active-card__name">{{ imp.ctx.customerName || 'Customer' }}</span>
                    <span class="assume-active-card__cid">{{ imp.ctx.cid }}</span>
                  </div>
                  <button class="assume-release-btn" (click)="imp.release()" title="Release impersonation">
                    <mat-icon>logout</mat-icon>
                    Release
                  </button>
                </div>
              }

              <ng-select
                class="assume-field assume-customer"
                [items]="accountOptions"
                bindValue="customer_id"
                [searchFn]="searchFn"
                [clearable]="true"
                [searchable]="true"
                [virtualScroll]="true"
                [placeholder]="imp.isImpersonating ? 'Switch to another customer…' : 'Search by name or CID…'"
                [formControl]="assumeCidCtrl"
                (keydown)="$event.stopPropagation()">
                <ng-template ng-option-tmp let-item="item">
                  <div class="assume-item">
                    <div class="assume-item__name">{{ item.name || item.Name }}</div>
                    <div class="assume-item__cid">{{ item.customer_id }}</div>
                  </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <div class="assume-item">
                    <div class="assume-item__name">{{ item.name || item.Name }}</div>
                    <div class="assume-item__cid">{{ item.customer_id }}</div>
                  </div>
                </ng-template>
              </ng-select>

              <button class="assume-btn" (click)="assumeSelected()" [disabled]="!assumeCidCtrl.value">
                <mat-icon>person_add</mat-icon>
                {{ imp.isImpersonating ? 'Switch Customer' : 'Assume' }}
              </button>
            </div>
          }


          <div class="menu-row menu-row--link">
            <mat-icon class="menu-row__icon">account_circle</mat-icon>
            <a routerLink="/profile" class="menu-row__text">My Profile</a>
          </div>

          <div class="menu-row menu-row--link" *ngIf="!isLoading && accounts?.length > 0"
            (click)="openAccountManagersModal()">
            <mat-icon class="menu-row__icon">support_agent</mat-icon>
            <span class="menu-row__text">Account Manager Info</span>
          </div>

          <div *ngIf="isAdmin" class="menu-row menu-row--toggle">
            <mat-icon class="menu-row__icon">theaters</mat-icon>
            <mat-slide-toggle (click)="$event.stopPropagation()" (change)="demoModeHandler($event)"
              [formControl]="demoModeControl" disableRipple>Demo Mode</mat-slide-toggle>
          </div>

          <div class="menu-row menu-row--toggle">
            <mat-icon class="menu-row__icon">dark_mode</mat-icon>
            <mat-slide-toggle [checked]="themeService.isDarkThemeSelected" (change)="toggleDarkMode($event)"
              disableRipple>Dark Mode</mat-slide-toggle>
          </div>

          <button (click)="onLogoutClick()" id="logout" mat-menu-item>
            <mat-icon>logout</mat-icon>
            Logout
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>

<nio-impersonation-banner *ngIf="isLoggedIn"></nio-impersonation-banner>
